import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import forEach from 'lodash.foreach';
import VT from '@/store/types';
import { modules, defaultState } from './modules';

Vue.use(Vuex);

const persist = new VuexPersistence({
  storage: window.localStorage,
  modules: [
    // 'OfflineModulesHERE',
    'Auth'
  ]
});

const store = new Vuex.Store({
  modules,
  plugins: [persist.plugin],

  actions: {
    [VT.RESET_TO_DEFAULT_STATE]: ({ rootState }, exceptions = []) => {
      let requiredReset = Object.keys(rootState);
      if (exceptions.length) {
        requiredReset = requiredReset.filter((el) => !exceptions.includes(el));
      }
      forEach(requiredReset, (module) => {
        rootState[module] = defaultState[module];
      });
    },
  }
});

export default store;
